import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import WebbeeLogo from "~franchise-website/svg/logos/Webbee";

const Footer = () => (
	<Grid
		container
		spacing={2}>
		<Grid
			container
			spacing={4}>
			<Grid
				item
				xs={12}
				md={6}
				display="flex"
				justifyContent="center">
				<Box
					display="flex"
					component="a"
					href="/"
					title="Mango Franchise"
					height={56}
					width={200}>
					<WebbeeLogo />
				</Box>
			</Grid>
			<Grid
				item
				container
				xs={12}
				md={6}
				sx={{ paddingTop: "10px" }}>
				<Grid
					item
					xs={12}>
					<Typography sx={{ textAlign: "center" }}>
						The world’s leading franchise sales & territory mapping software.
					</Typography>
				</Grid>
				<Grid
					item
					container
					xs={12}>
					<Grid
						item
						xs={12}
						md={4}
						display="flex"
						justifyContent="center">
						🇺🇸 +1 312 278 7054&nbsp;&nbsp;
					</Grid>
					<Grid
						item
						xs={12}
						md={4}
						display="flex"
						justifyContent="center">
						🇬🇧 +44 1172 301999&nbsp;&nbsp;
					</Grid>
					<Grid
						item
						xs={12}
						md={4}
						display="flex"
						justifyContent="center">
						🇦🇺 +61 7 3059 9450
					</Grid>
				</Grid>
			</Grid>
		</Grid>
		<Grid
			item
			xs={12}>
			<Typography
				align="center"
				variant="caption"
				color="textSecondary"
				component="p">
				&copy; 2023 Mangomap LIMITED. All rights reserved. When you visit or
				interact with our sites, services or tools, we or our authorised service
				providers may use cookies for storing information to help provide you
				with a better, faster and safer experience and for marketing purposes.
			</Typography>
		</Grid>
	</Grid>
);

export default Footer;
